import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { TaskFilter } from "../../interfaces/task-filter";

interface TipiTaskResponse {
    nomeTipiTask: string[];
}

@Injectable({ providedIn: 'root' })
export class TaskFilterService {

    // Cache filtri
    private _savedFilters: TaskFilter | null = null;
    
    constructor(
        private http: HttpClient
    ) {}

    getTipiTask(): Observable<string[]> {
        return this.http
            .get<TipiTaskResponse>('api/taskapprovativi/NomeTipiTask')
            .pipe(map(response => response.nomeTipiTask));
    }

    setSavedFilters(filters: TaskFilter) {
        this._savedFilters = { ...filters };
    }

    getSavedFilters(): TaskFilter | null {
        return this._savedFilters;
    }

    clearFilters() {
        this._savedFilters = null;
    }
}